import { formatParamsGet, getDataFromServer } from "../util";

export const getCountries = () => getDataFromServer("GET", `/user/countries`, null, true);
// export const getCountries = () => getDataFromServer("GET", `/locations/countries`, null, true);

export const getStates = (countriesList) => {
  countriesList = countriesList.map((country) => encodeURIComponent(country));
  return getDataFromServer("GET", `/locations/available-states?countries=${countriesList}`, null, true);
};

export const getCities = (params) => {
  const formattedParams = formatParamsGet(params);
  const endpoint = `/locations/available-cities${formattedParams}`;
  return getDataFromServer("GET", endpoint, null, true);
};
